import { useEffect, useState } from "react";
import { toast } from "sonner";
import { crearPrograma, listarPrograma, listarActividades, exportarPDFURL, exportarExcelURL } from "./api";

const hoy = () => new Date().toISOString().slice(0, 10);

export default function VistaJefe({ user }) {
  const [tab, setTab] = useState("programa");
  return (
    <div data-testid="vista-jefe">
      <div className="via-tabs" style={{ borderRadius: 12, marginBottom: 12 }}>
        <button className={`via-tab ${tab === "programa" ? "active" : ""}`} onClick={() => setTab("programa")} data-testid="tab-jefe-programa">Programa de hoy</button>
        <button className={`via-tab ${tab === "registros" ? "active" : ""}`} onClick={() => setTab("registros")} data-testid="tab-jefe-registros">Ver registros</button>
      </div>
      {tab === "programa" ? <TabPrograma user={user}/> : <TabRegistrosJefe user={user}/>}
    </div>
  );
}

function TabPrograma({ user }) {
  const [fecha, setFecha] = useState(hoy());
  const [entradas, setEntradas] = useState([{ trabajador_nombre: "", unidad: "", actividad: "", zona: "", supervisor: "", cuadrilla: "" }]);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => { cargar(); /* eslint-disable-next-line */ }, [fecha]);
  const cargar = async () => {
    try {
      const r = await listarPrograma({ fecha });
      if ((r.items || []).length) {
        setEntradas(r.items.map(x => ({
          id: x.id,
          trabajador_nombre: x.trabajador_nombre || "",
          unidad: x.unidad || "",
          actividad: x.actividad || "",
          zona: x.zona || "",
          supervisor: x.supervisor || "",
          cuadrilla: x.cuadrilla || "",
        })));
      } else {
        setEntradas([{ trabajador_nombre: "", unidad: "", actividad: "", zona: "", supervisor: "", cuadrilla: "" }]);
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error cargando programa");
    }
  };

  const addRow = () => setEntradas([...entradas, { trabajador_nombre: "", unidad: "", actividad: "", zona: "", supervisor: "", cuadrilla: "" }]);
  const rmRow = (i) => setEntradas(entradas.filter((_, j) => j !== i));
  const updRow = (i, k, v) => setEntradas(entradas.map((r, j) => j === i ? { ...r, [k]: v } : r));

  const enviar = async () => {
    const validas = entradas.filter(e => e.trabajador_nombre.trim());
    if (!validas.length) { toast.error("Agrega al menos un trabajador"); return; }
    setGuardando(true);
    try {
      const r = await crearPrograma(fecha, validas);
      toast.success(`Programa guardado · ${r.entradas} trabajadores`);
      cargar();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error guardando programa");
    } finally { setGuardando(false); }
  };

  return (
    <div className="via-card" data-testid="card-jefe-programa">
      <h2><i className="fa-solid fa-clipboard-list"/> Programa de hoy</h2>
      <div className="via-form-row">
        <label>Fecha</label>
        <input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} data-testid="jefe-fecha"/>
      </div>
      <div style={{ overflowX: "auto" }}>
        <table className="via-tabla" data-testid="jefe-tabla">
          <thead>
            <tr><th>Trabajador</th><th>Unidad</th><th>Zona/Lugar</th><th>Actividad</th><th>Supervisor</th><th></th></tr>
          </thead>
          <tbody>
            {entradas.map((e, i) => (
              <tr key={i}>
                <td><input value={e.trabajador_nombre} onChange={(ev) => updRow(i, "trabajador_nombre", ev.target.value)} placeholder="Nombre"/></td>
                <td><input value={e.unidad} onChange={(ev) => updRow(i, "unidad", ev.target.value)} placeholder="Unidad" style={{ width: 100 }}/></td>
                <td><input value={e.zona} onChange={(ev) => updRow(i, "zona", ev.target.value)} placeholder="Zona/Lugar"/></td>
                <td><input value={e.actividad} onChange={(ev) => updRow(i, "actividad", ev.target.value)} placeholder="Actividad"/></td>
                <td><input value={e.supervisor} onChange={(ev) => updRow(i, "supervisor", ev.target.value)} placeholder="Supervisor"/></td>
                <td><button className="via-btn-danger" onClick={() => rmRow(i)} aria-label="Quitar fila">×</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
        <button className="via-btn-ghost" onClick={addRow} data-testid="jefe-add-row"><i className="fa-solid fa-plus"/> Agregar trabajador</button>
        <button className="via-btn" disabled={guardando} onClick={enviar} data-testid="jefe-enviar">
          {guardando ? "Enviando…" : "Enviar programa"}
        </button>
      </div>
    </div>
  );
}

function TabRegistrosJefe({ user }) {
  const [items, setItems] = useState([]);
  const [fdesde, setFdesde] = useState(hoy());
  const [fhasta, setFhasta] = useState(hoy());

  useEffect(() => { cargar(); /* eslint-disable-next-line */ }, [fdesde, fhasta]);
  const cargar = async () => {
    try {
      const r = await listarActividades({ fecha_desde: fdesde, fecha_hasta: fhasta });
      setItems(r.items || []);
    } catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };

  const descargarPDF = () => window.open(exportarPDFURL({ fecha_desde: fdesde, fecha_hasta: fhasta }), "_blank");
  const descargarExcel = () => window.open(exportarExcelURL({ fecha_desde: fdesde, fecha_hasta: fhasta }), "_blank");

  return (
    <div className="via-card">
      <h2><i className="fa-solid fa-list-check"/> Registros de mis cuadrillas</h2>
      <div className="via-form-grid">
        <div className="via-form-row"><label>Desde</label><input type="date" value={fdesde} onChange={(e) => setFdesde(e.target.value)}/></div>
        <div className="via-form-row"><label>Hasta</label><input type="date" value={fhasta} onChange={(e) => setFhasta(e.target.value)}/></div>
      </div>
      <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
        <button className="via-btn-ghost" onClick={descargarPDF}><i className="fa-solid fa-file-pdf"/> PDF</button>
        <button className="via-btn-ghost" onClick={descargarExcel}><i className="fa-solid fa-file-excel"/> Excel</button>
      </div>
      <div style={{ overflowX: "auto" }}>
        <table className="via-tabla" data-testid="jefe-registros-tabla">
          <thead><tr><th>Fecha</th><th>Empleado</th><th>Área</th><th>Lugar</th><th>Estatus</th><th>Bolsas/kg</th></tr></thead>
          <tbody>
            {items.map(it => (
              <tr key={it.id}>
                <td>{it.fecha}</td>
                <td>{it.nombre_empleado || it.lider_usuario}</td>
                <td>{it.area_intervencion}</td>
                <td>{it.intervencion_en || "—"}</td>
                <td><span className={`via-badge via-badge-${(it.estatus || "pendiente").toLowerCase().replace(/ /g, "")}`}>{it.estatus}</span></td>
                <td>{it.bolsas_negras || 0} / {it.basura_kg || 0}kg</td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan={6} className="via-empty">Sin registros</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
